import { Injectable } from '@angular/core';
import { PlatformService } from './platform.service';
import { Geolocation } from '@capacitor/geolocation';
import { logger } from 'src/app/common/services/logging/logging.service';

@Injectable({
    providedIn: 'root'
})
export class LocationService {

    constructor() {
        this.requestPermission();
    }

    private async requestPermission(): Promise<boolean> {
        if (!PlatformService.isMobile()) return false;

        let permStatus = await Geolocation.checkPermissions();

        if (permStatus.location === 'prompt') {
            permStatus = await Geolocation.requestPermissions();
        }

        if (permStatus.location !== 'granted') {
            logger.error('User denied location permissions!');
            return false;
        }

        return true;
    }

    public async getCurrentLocation(): Promise<LocationData> {
        let isPermitted = await this.requestPermission();
        if (!isPermitted) return EmptyLocationData;
        let location = await Geolocation.getCurrentPosition();

        let locationData: LocationData = {
            latitude: location.coords.latitude,
            longitude: location.coords.longitude
        };
        return locationData;
    }

}

export interface LocationData {
    latitude: number | null;
    longitude: number | null;
}

export const EmptyLocationData: LocationData = {
    latitude: null,
    longitude: null
};